import React from "react";
import GrayIcon from "assets/images/png/gray.jpg";
import Rating from "pages/details/components/rating";
import DeleteIcon from "assets/images/svg/delete.svg";
import EditIcon from "assets/images/svg/edit.svg";
import {client} from "helpers/client";
import {useQueryClient} from "react-query";
import ReviewDialog from "pages/details/components/review-dialog";
import {useModal} from "hooks";
import {toast} from "react-toastify";
import {useParams} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {formatDate, json} from "../../../helpers/data";

export interface Review {
  customerImage: null;
  status: string;
  id: number;
  rateDate: Date;
  rate: number;
  review: string;
  createDate: Date;
  approvedDate: Date;
  applicationName: string;
  customerName: string;
}

interface Props {
  review: Review;
  showControls? : boolean
}

function ReviewCard({ review,showControls = false }: Props) {
  const {t} = useTranslation()
  const appId = +useParams().id!
  const [show,open,close] = useModal(false)
  const queryClient = useQueryClient()
  
  const handleDeleteReview = () => {
    client('/customerReview/delete',{params:{id:review.id},method:"POST"}).then(({response}) => {
      if(response) {
        toast.success(t('common:form.removed'))
        queryClient.invalidateQueries("my-review");
        queryClient.invalidateQueries(['app-details',appId])
      }
    })
  }

  const handleUpdateReview =() => {
    open()
  }
  return (
    <div className="review-card">
      <div className="review-header">
        <div className="info">
          <img className="logo" src={GrayIcon} alt="customer-pic" />
          <div>
            <h2 className="title">
              {review.customerName}
              {showControls && <span className="pending">{json((`${review.status}`))}</span>}
            </h2>
            <div className="info-rate">
              <Rating readOnly rating={review.rate} size="small" />
              <span className='ps-3'>{formatDate(review.rateDate, {showTime:true})}</span>
            </div>
          </div>
        </div>
        {showControls && (
          <div className="action">
            <img
              src={DeleteIcon}
              alt="delete-icon"
              onClick={handleDeleteReview}
            />
            <img src={EditIcon} alt="edit-icon" onClick={handleUpdateReview} />
          </div>
        )}
      </div>
      <p className="message">{review.review}</p>
      <ReviewDialog onHide={close} show={show} appId={5} review={review} />
    </div>
  );
}

export default ReviewCard;
